// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__kcEmn"};